import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
} from "./actionTypes"

const authUserStr = localStorage.getItem("authUser");
let parsedUser = null;
try {
  parsedUser = authUserStr ? JSON.parse(authUserStr) : null;
} catch (e) {
  parsedUser = null;
}

const initialState = {
  error: "",
  loading: false,
  user: parsedUser,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        user:action.payload
      }
      break
    case LOGOUT_USER:
      state = { ...state, user: null, error: "" }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state, user: null, error: "" }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
